import React, { useState } from 'react';
import { StarIcon } from 'lucide-react';
import { SectionTitle } from './SectionTitle';
import { reviews } from '../../data/artTherapy';
function initials(name: string) {
  return name.replace('.', '').split(' ').map(p => p[0]).join('');
}

/** Kb. 4,5 mp kártyánként — a teljes kör ideje. */
const SECONDS_PER_CARD = 4.5;
export function Reviews() {
  const [paused, setPaused] = useState(false);
  const loop = [...reviews, ...reviews];
  return <section aria-labelledby="reviews-title" className="relative overflow-hidden bg-gradient-to-b from-cream to-peach py-14 md:py-20" data-id="element-235" data-mp="wo26ymr41arq">
      <span aria-hidden="true" className="absolute -right-24 top-40 h-72 w-72 rounded-full bg-[#F9E6DE]/70" data-id="element-236" data-mp="mrpgryurxf1q" />
      <div className="relative px-5" data-id="element-237" data-mp="hu7eusf6c038">
        <SectionTitle id="reviews-title" subtitle="Fordított vélemények: eredetileg más nyelveken íródtak." data-id="element-238" data-mp="hv8qoz40kqm0">
          Mit mondanak, akik kipróbálták
        </SectionTitle>
      </div>

      <div className="reviews-marquee-viewport relative mt-8 pb-4" aria-label="Vélemények" data-id="element-239" data-mp="2c7osnnps1il2">
        <div className="reviews-marquee-track flex w-max items-stretch" style={{
        animationDuration: `${reviews.length * SECONDS_PER_CARD}s`,
        animationPlayState: paused ? 'paused' : 'running'
      }} onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)} onTouchStart={() => setPaused(true)} onTouchEnd={() => setPaused(false)} onTouchCancel={() => setPaused(false)} data-id="element-240" data-mp="1f93nqyod952o">
          {loop.map((r, idx) => <article key={`${r.name}-${idx}`} aria-hidden={idx >= reviews.length ? true : undefined} className="mr-4 flex w-[60vw] max-w-[330px] shrink-0 flex-col rounded-3xl border border-[#F1E6E0] bg-white p-6 shadow-[0_10px_30px_-20px_rgba(74,58,53,0.4)] sm:mr-5 sm:w-[330px]" data-id="element-241" data-mp="2323nqpxr7lg0" data-mpi={idx}>
              <div className="flex items-center gap-4" data-id="element-242" data-mp="2lr0jky8sum0c">
                <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-lavender-soft font-display text-lg font-bold text-lavender-deep ring-2 ring-lavender" aria-hidden="true" data-id="element-243" data-mp="2lslfar6uoazs">
                  {initials(r.name)}
                </span>
                <div data-id="element-244" data-mp="2mkq6p6ykfl3e">
                  <div className="flex gap-0.5 text-gold" aria-label="5 csillag" data-id="element-245" data-mp="2mo5ls9s8ou4t">
                    {Array.from({
                  length: 5
                }).map((_, i) => <StarIcon key={i} className="h-3.5 w-3.5 fill-current" aria-hidden="true" data-id="element-246" data-mp="2co4y6bnc7rut" data-mpi={i} />)}
                  </div>
                  <p className="mt-1 font-display text-lg font-bold text-ink" data-id="element-247" data-mp="27vtzfc4c2c3u">{r.name}</p>
                </div>
              </div>
              <blockquote className="mt-4 text-[17px] italic leading-relaxed text-body" data-id="element-248" data-mp="1ywgp6h8dxji2">{r.quote}</blockquote>
            </article>)}
        </div>
      </div>
    </section>;
}